// import React, { useState, useEffect, useContext, useCallback } from "react";
// import { AuthContext } from "../context/AuthContext";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import { FiEdit, FiTrash2, FiX, FiUpload, FiDownload } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import { FaSearch, FaTimes } from "react-icons/fa";
// import { Select } from "antd";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { CloudArrowUpIcon } from "@heroicons/react/24/outline";

// const ConvertedLeads = () => {
//   const { user } = useContext(AuthContext);
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isSearching, setIsSearching] = useState(false);
//   const [isSearchMode, setIsSearchMode] = useState(false);
//   const [showSearchFields, setShowSearchFields] = useState(false);
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
//   const [users, setUsers] = useState([]);
//   const [showUploadSection, setShowUploadSection] = useState(false);
//   const [file, setFile] = useState(null);
//   const [selectedUser, setSelectedUser] = useState("");
//   const [editingLead, setEditingLead] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [leadToDelete, setLeadToDelete] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const navigate = useNavigate();
//   const [searchParams, setSearchParams] = useState({
//     targetUserId: "",
//     startDate: "",
//     endDate: "",
//     query: "",
//     createdAt: "",
//   });

//   // Form state for editing lead
//   const [editForm, setEditForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     companyName: "",
//     address: "",
//   });

//   const fetchUsers = useCallback(async () => {
//     if (!user?.id) return;
//     try {
//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       const response = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       setUsers(response.data || []);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   }, [user]);

//   const fetchLeads = useCallback(
//     async (page = 0) => {
//       try {
//         setLoading(true);
//         const endpoint = `${API_URL}/api/convertedLeads/customers/${user.id}?pageNumber=${page}&pageSize=${pageSize}`;

//         const response = await axios.get(endpoint, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });

//         setLeads(response.data.customers || []);
//         setTotalPages(response.data.totalPages || 0);
//         setPageNumber(page); // Update current page number
//       } catch (error) {
//         console.log("Failed to fetch leads")
//         // toast.error("Failed to fetch leads");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [user, pageSize]
//   );

//   useEffect(() => {
//     fetchUsers();
//     fetchLeads();
//   }, [fetchLeads, fetchUsers, pageNumber, pageSize]);

//   const handleUnconvertClick = (lead) => {
//     setLeadToDelete(lead);
//     setShowDeleteModal(true);
//   };

//   const handleUnconvertLead = async () => {
//     if (!leadToDelete) return;

//     try {
//       await axios.delete(
//         `${API_URL}/api/convertedLeads/unConvertLead/${leadToDelete.customerId}`,
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         }
//       );
//       setLeads(
//         leads.filter((lead) => lead.customerId !== leadToDelete.customerId)
//       );
//       toast.success("Lead unconverted successfully");
//     } catch (error) {
//       toast.error("Failed to unconvert lead");
//     } finally {
//       setShowDeleteModal(false);
//       setLeadToDelete(null);
//     }
//   };

//   const isMaskedPhone = (value) => /^X+\d{0,3}$/.test(value || "");

//   const handleEditClick = (lead) => {
//     setEditingLead(lead);
//     setEditForm({
//       name: lead.name,
//       email: lead.email,
//       phone: isMaskedPhone(lead.phone) ? "" : lead.phone || "",
//       companyName: lead.companyName || "",
//       address: lead.address || "",
//     });
//     setShowEditModal(true);
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = { ...editForm };
//       if (isMaskedPhone(editingLead?.phone) && !payload.phone) {
//         delete payload.phone;
//       }
//       const response = await axios.put(
//         `${API_URL}/api/convertedLeads/update/${editingLead.customerId}/changedBy/${user.id}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       toast.success("Lead updated successfully");
//       setShowEditModal(false);
//       // Refresh leads data
//       fetchLeads(pageNumber);
//     } catch (error) {
//       toast.error("Failed to update lead");
//       console.error("Error updating lead:", error);
//     }
//   };

//   const handleFileChange = (e) => {
//     const uploadedFile = e.target.files[0];
//     if (uploadedFile) {
//       const fileExtension = uploadedFile.name.split(".").pop().toLowerCase();
//       if (["xls", "xlsx", "csv"].includes(fileExtension)) {
//         setFile(uploadedFile);
//       } else {
//         toast.error(
//           "Only Excel (.xlsx, .xls) and CSV (.csv) files are allowed."
//         );
//         setFile(null);
//       }
//     }
//   };

//   const handleUploadFile = async (event) => {
//     event.preventDefault();
//     if (!file) {
//       toast.error("Please select a valid file before uploading.");
//       return;
//     }

//     if (!selectedUser) {
//       toast.error("Please select an assigned user.");
//       return;
//     }

//     const assignedUser = users.find((user) => user.id === selectedUser);
//     if (!assignedUser) {
//       toast.error("Assigned user not found.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append(
//       "companyId",
//       user.accountType === "COMPANY" ? user?.id : user.companyId
//     );
//     formData.append("createdById", user.id);
//     formData.append("createdByName", user.name);
//     formData.append("assignedToId", assignedUser.id);
//     formData.append(
//       "assignedToName",
//       `${assignedUser.fname} ${assignedUser.lname}`
//     );

//     try {
//       const response = await axios.post(
//         `${API_URL}/api/convertedLeads/import/sheet`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       toast.success(response.data.message);
//       setShowUploadSection(false);
//       fetchLeads(pageNumber); // Refresh leads after upload
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error(
//         error.response?.data?.message ||
//           "Error uploading file. Please try again."
//       );
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const worksheet = XLSX.utils.json_to_sheet([
//       {
//         "Lead Name": "",
//         Email: "",
//         Phone: "",
//         companyName: "",
//         "leadDate(02/05/2025)": "",
//         Address: "",
//       },
//     ]);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });
//     const blob = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });

//     saveAs(blob, "converted_lead_template.xlsx");
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);
//     setIsSearchMode(true);
//     setPageNumber(0);

//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       const token = localStorage.getItem("token");
//       if (!token) {
//         toast.error("Authentication token not found");
//         return;
//       }

//       const params = {
//         pageNumber: 0,
//         pageSize: pageSize,
//         ...Object.fromEntries(
//           Object.entries(searchParams).filter(([_, value]) => value !== "")
//         ),
//       };

//       const response = await axios.get(
//         `${API_URL}/api/convertedLeads/customers/${user?.id}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setLeads(response.data?.customers || []);
//       setTotalPages(response.data?.totalPages || 0);
//       toast.success(`Found ${response.data?.customers?.length || 0} results`);
//     } catch (error) {
//       console.error("Search failed:", error);
//       toast.error(
//         error.response?.data?.message || "Search failed. Please try again."
//       );
//       setLeads([]);
//       setTotalPages(0);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   const handleClearSearch = async () => {
//     setSearchParams({
//       targetUserId: "",
//       startDate: "",
//       endDate: "",
//       query: "",
//       createdAt: "",
//     });
//     setIsSearchMode(false);
//     setPageNumber(0);
//     await fetchLeads(0);
//     toast.success("Search cleared");
//   };

//   const handlePageSizeChange = (value) => {
//     setPageSize(value);
//     setPageNumber(0);
//     if (isSearchMode) {
//       handleSearchSubmit({ preventDefault: () => {} }); // Refetch with new page size
//     } else {
//       fetchLeads(0);
//     }
//   };

//   return (
//     <div className="container mx-auto p-1 dark:bg-gray-900 dark:text-white text-xs">
//       <div className="bg-white shadow rounded-lg p-2 dark:bg-gray-900 dark:text-white">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-2 gap-2">
//           <h2 className="text-lg font-semibold">Converted Leads</h2>
//           <div className="flex gap-1">
//             <button
//               type="button"
//               onClick={() => setShowUploadSection(!showUploadSection)}
//               className="p-1 bg-purple-500 text-white rounded-full hover:bg-purple-600 transition-colors"
//               title="Upload leads"
//             >
//               <CloudArrowUpIcon className="w-4 h-4" />
//             </button>
//             <button
//               type="button"
//               onClick={() => setShowSearchFields(!showSearchFields)}
//               className="flex items-center gap-1 px-2 py-1 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-xs"
//             >
//               <FaSearch className="text-xs" />
//               {showSearchFields ? "Hide Search" : "Search"}
//             </button>
//           </div>
//         </div>

//         {/* Upload Section */}
//         {showUploadSection && (
//           <div className="relative bg-white mt-1 p-2 rounded shadow mb-2 border border-gray-200 dark:bg-gray-900 dark:text-white text-xs">
//             <button
//               onClick={() => setShowUploadSection(false)}
//               className="absolute top-1 right-1 text-gray-500 hover:text-gray-700"
//               aria-label="Close upload section"
//             >
//               <FiX className="h-4 w-4" />
//             </button>

//             <div className="space-y-2">
//               <div>
//                 <label className="block text-xs font-medium mb-1">
//                   Assign User
//                 </label>
//                 <Select
//                   showSearch
//                   placeholder="Select user"
//                   value={selectedUser || undefined}
//                   onChange={(value) => setSelectedUser(value)}
//                   options={users.map((user) => ({
//                     value: user.id,
//                     label: `${user.fname} ${user.lname}`,
//                   }))}
//                   className="w-full"
//                   filterOption={(input, option) =>
//                     option.label.toLowerCase().includes(input.toLowerCase())
//                   }
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium mb-1">
//                   Upload File
//                 </label>
//                 <input
//                   type="file"
//                   onChange={handleFileChange}
//                   className="w-full p-1 border rounded text-xs"
//                   accept=".xlsx,.xls,.csv"
//                 />
//               </div>

//               <div className="text-xs text-gray-600">
//                 <p>
//                   To preview the Excel format, click{" "}
//                   <button
//                     onClick={downloadExcelTemplate}
//                     className="text-blue-500 underline hover:text-blue-700"
//                   >
//                     here
//                   </button>
//                   .
//                 </p>
//               </div>

//               <button
//                 onClick={handleUploadFile}
//                 className="mt-1 p-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors flex items-center gap-1 text-xs"
//               >
//                 <FiUpload className="w-3 h-3" />
//                 Upload
//               </button>
//             </div>
//           </div>
//         )}

//         {showSearchFields && (
//           <form
//             onSubmit={handleSearchSubmit}
//             className="bg-gray-50 p-2 rounded-lg mb-3 shadow-sm dark:bg-gray-800 dark:text-white text-xs"
//           >
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 dark:bg-gray-800 dark:text-white">
//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5 dark:text-white">
//                   User
//                 </label>
//                 <Select
//                   showSearch
//                   allowClear
//                   placeholder="Select user"
//                   value={searchParams.targetUserId || undefined}
//                   onChange={(value) =>
//                     setSearchParams((prev) => ({
//                       ...prev,
//                       targetUserId: value,
//                     }))
//                   }
//                   options={users.map((user) => ({
//                     value: user.id,
//                     label: `${user.fname} ${user.lname}`,
//                   }))}
//                   className="w-full dark:bg-gray-800"
//                   filterOption={(input, option) =>
//                     option.label.toLowerCase().includes(input.toLowerCase())
//                   }
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5 dark:text-white">
//                   Created At
//                 </label>
//                 <input
//                   type="date"
//                   name="createdAt"
//                   value={searchParams.createdAt}
//                   onChange={handleChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 text-xs"
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5 dark:text-white">
//                   From Date
//                 </label>
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={searchParams.startDate}
//                   onChange={handleChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 text-xs"
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5 dark:text-white">
//                   To Date
//                 </label>
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={searchParams.endDate}
//                   onChange={handleChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 text-xs"
//                 />
//               </div>

//               <div className="sm:col-span-2">
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5 dark:text-white">
//                   Search Query
//                 </label>
//                 <input
//                   type="text"
//                   name="query"
//                   placeholder="Search by keyword"
//                   value={searchParams.query}
//                   onChange={handleChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 text-xs"
//                 />
//               </div>
//             </div>

//             <div className="flex justify-end gap-2 mt-2">
//               <button
//                 type="button"
//                 onClick={handleClearSearch}
//                 className="px-2 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors flex items-center gap-1 text-xs"
//               >
//                 <FaTimes className="text-xs" />
//                 Clear
//               </button>
//               <button
//                 type="submit"
//                 className={`px-2 py-1 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors flex items-center gap-1 text-xs ${
//                   isSearching ? "opacity-75 cursor-not-allowed" : ""
//                 }`}
//                 disabled={isSearching}
//               >
//                 {isSearching ? (
//                   <>
//                     <svg className="animate-spin h-3 w-3" viewBox="0 0 24 24">
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                       ></path>
//                     </svg>
//                     Searching...
//                   </>
//                 ) : (
//                   <>
//                     <FaSearch className="text-xs" />
//                     Search
//                   </>
//                 )}
//               </button>
//             </div>
//           </form>
//         )}

//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200 text-xs">
//             <thead className="bg-gray-50 dark:bg-gray-900 dark:text-white">
//               <tr>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Name
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Email
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Phone
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Company
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Converted By
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Converted Date
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Lead Details
//                 </th>
//                 <th className="px-3 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:text-white">
//               {loading ? (
//                 <tr>
//                   <td colSpan="8" className="px-3 py-2 text-center">
//                     <div className="flex justify-center">
//                       <svg
//                         className="animate-spin h-5 w-5 text-indigo-600"
//                         viewBox="0 0 24 24"
//                       >
//                         <circle
//                           className="opacity-25"
//                           cx="12"
//                           cy="12"
//                           r="10"
//                           stroke="currentColor"
//                           strokeWidth="4"
//                         ></circle>
//                         <path
//                           className="opacity-75"
//                           fill="currentColor"
//                           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                         ></path>
//                       </svg>
//                     </div>
//                   </td>
//                 </tr>
//               ) : leads.length > 0 ? (
//                 leads.map((lead) => (
//                   <tr key={lead.customerId} className="hover:bg-gray-50 dark:hover:bg-gray-900 dark:text-white">
//                     <td className="px-3 py-1 whitespace-nowrap text-xs font-medium text-gray-900 dark:text-white">
//                       {lead.name}
//                     </td>
//                     <td className="px-3 py-1 whitespace-nowrap text-xs text-gray-500 dark:text-white">
//                       {lead.email}
//                     </td>
//                     <td className="px-3 py-1 whitespace-nowrap text-xs text-gray-500 dark:text-white">
//                       {lead.phone || "-"}
//                     </td>
//                     <td className="px-3 py-1 whitespace-nowrap text-xs text-gray-500 dark:text-white">
//                       {lead.companyName || "-"}
//                     </td>
//                     <td className="px-3 py-1 whitespace-nowrap text-xs text-gray-500 dark:text-white">
//                       {lead.convertedByName}
//                     </td>
//                     <td className="px-3 py-1 whitespace-nowrap text-xs text-gray-500 dark:text-white">
//                       {new Date(lead.convertedDate).toLocaleString()}
//                     </td>
//                     <td className="px-3 py-1 text-xs text-gray-500 dark:text-white">
//                       {lead.lead ? (
//                         <div className="leading-tight">
//                           <div>
//                             {lead.lead.status || "-"}
//                             {lead.lead.sourceName ? ` · ${lead.lead.sourceName}` : ""}
//                           </div>
//                           <div className="text-gray-400">
//                             {lead.lead.projectName || ""}
//                             {lead.lead.assignedToName ? ` · ${lead.lead.assignedToName}` : ""}
//                           </div>
//                         </div>
//                       ) : (
//                         "-"
//                       )}
//                     </td>
//                     <td className="px-3 py-1 whitespace-nowrap text-xs text-gray-500 dark:text-white">
//                       {(user?.id === lead.convertedById ||
//                         user?.accountType === "COMPANY") && (
//                         <div className="flex space-x-1">
//                           <button
//                             onClick={() => handleEditClick(lead)}
//                             className="text-indigo-600 hover:text-indigo-900 p-0.5 rounded hover:bg-indigo-50"
//                             title="Edit"
//                           >
//                             <FiEdit className="h-3 w-3" />
//                           </button>
//                           <button
//                             onClick={() => handleUnconvertClick(lead)}
//                             className="text-red-600 hover:text-red-900 p-0.5 rounded hover:bg-red-50"
//                             title="Unconvert"
//                           >
//                             <FiTrash2 className="h-3 w-3" />
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="8"
//                     className="px-3 py-2 text-center text-xs text-gray-500"
//                   >
//                     No converted leads found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {totalPages > 0 && (
//           <div className="mt-3 flex flex-col sm:flex-row justify-between items-center gap-2">
//             <div className="flex items-center gap-1">
//               <span className="text-xs text-gray-600 dark:text-white">Items per page:</span>
//               <Select
//                 defaultValue={10}
//                 value={pageSize}
//                 onChange={handlePageSizeChange}
//                 className="w-16 text-xs"
//                 options={[
//                   { value: 5, label: "5" },
//                   { value: 10, label: "10" },
//                   { value: 20, label: "20" },
//                   { value: 50, label: "50" },
//                 ]}
//               />
//             </div>

//             <div className="flex flex-wrap justify-center items-center gap-1 sm:gap-2">
//               <button
//                 onClick={() => {
//                   setPageNumber(0);
//                   if (isSearchMode) {
//                     handleSearchSubmit({ preventDefault: () => {} });
//                   } else {
//                     fetchLeads(0);
//                   }
//                 }}
//                 disabled={pageNumber === 0}
//                 className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs"
//               >
//                 First
//               </button>

//               <button
//                 onClick={() => {
//                   const newPage = Math.max(pageNumber - 1, 0);
//                   setPageNumber(newPage);
//                   if (isSearchMode) {
//                     handleSearchSubmit({ preventDefault: () => {} });
//                   } else {
//                     fetchLeads(newPage);
//                   }
//                 }}
//                 disabled={pageNumber === 0}
//                 className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs"
//               >
//                 Previous
//               </button>

//               <span className="text-xs font-medium text-gray-700 dark:text-white px-1">
//                 Page {pageNumber + 1} of {totalPages}
//               </span>

//               <button
//                 onClick={() => {
//                   const newPage = Math.min(pageNumber + 1, totalPages - 1);
//                   setPageNumber(newPage);
//                   if (isSearchMode) {
//                     handleSearchSubmit({ preventDefault: () => {} });
//                   } else {
//                     fetchLeads(newPage);
//                   }
//                 }}
//                 disabled={pageNumber >= totalPages - 1}
//                 className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs"
//               >
//                 Next
//               </button>

//               <button
//                 onClick={() => {
//                   setPageNumber(totalPages - 1);
//                   if (isSearchMode) {
//                     handleSearchSubmit({ preventDefault: () => {} });
//                   } else {
//                     fetchLeads(totalPages - 1);
//                   }
//                 }}
//                 disabled={pageNumber >= totalPages - 1}
//                 className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs"
//               >
//                 Last
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Edit Lead Modal */}
//       {showEditModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 z-50">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-md text-xs">
//             <div className="flex justify-between items-center border-b p-2">
//               <h3 className="text-md font-semibold">Edit Lead</h3>
//               <button
//                 onClick={() => setShowEditModal(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FiX className="h-4 w-4" />
//               </button>
//             </div>
//             <form onSubmit={handleEditSubmit} className="p-2 space-y-2">
//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5">
//                   Name
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={editForm.name}
//                   onChange={handleEditFormChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-xs"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5">
//                   Email
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={editForm.email}
//                   onChange={handleEditFormChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-xs"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5">
//                   Phone
//                 </label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={editForm.phone}
//                   placeholder={isMaskedPhone(editingLead?.phone) ? "Hidden - leave blank to keep" : ""}
//                   onChange={handleEditFormChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-xs"
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5">
//                   Company Name
//                 </label>
//                 <input
//                   type="text"
//                   name="companyName"
//                   value={editForm.companyName}
//                   onChange={handleEditFormChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-xs"
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-0.5">
//                   Address
//                 </label>
//                 <textarea
//                   name="address"
//                   value={editForm.address}
//                   onChange={handleEditFormChange}
//                   className="w-full p-1 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-xs"
//                   rows="2"
//                 ></textarea>
//               </div>

//               <div className="flex justify-end gap-2 pt-2">
//                 <button
//                   type="button"
//                   onClick={() => setShowEditModal(false)}
//                   className="px-2 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors text-xs"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="px-2 py-1 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-xs"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
      
//       {/* Delete Confirmation Modal */}
//       {showDeleteModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 z-50">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-md text-xs">
//             <div className="flex justify-between items-center border-b p-2">
//               <h3 className="text-md font-semibold">Confirm Unconvert</h3>
//               <button
//                 onClick={() => {
//                   setShowDeleteModal(false);
//                   setLeadToDelete(null);
//                 }}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FiX className="h-4 w-4" />
//               </button>
//             </div>
//             <div className="p-2">
//               <p className="mb-2 text-xs">
//                 Are you sure you want to unconvert this lead? This action cannot
//                 be undone.
//               </p>
//               <div className="flex justify-end gap-2">
//                 <button
//                   onClick={() => {
//                     setShowDeleteModal(false);
//                     setLeadToDelete(null);
//                   }}
//                   className="px-2 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors text-xs"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleUnconvertLead}
//                   className="px-2 py-1 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-xs"
//                 >
//                   Unconvert
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ConvertedLeads;










import React, { useState, useEffect, useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";
import { FiEdit, FiTrash2, FiX, FiUpload, FiDownload } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaTimes } from "react-icons/fa";
import { Select } from "antd";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";

const ConvertedLeads = () => {
  const { user } = useContext(AuthContext);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [users, setUsers] = useState([]);
  const [showUploadSection, setShowUploadSection] = useState(false);
  const [file, setFile] = useState(null);
  const [selectedUser, setSelectedUser] = useState("");
  const [editingLead, setEditingLead] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadToDelete, setLeadToDelete] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useState({
    targetUserId: "",
    startDate: "",
    endDate: "",
    query: "",
    createdAt: "",
  });

  // Form state for editing lead
  const [editForm, setEditForm] = useState({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    address: "",
  });

  const fetchUsers = useCallback(async () => {
    if (!user?.id) return;
    try {
      const url =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setUsers(response.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, [user]);

  const fetchLeads = useCallback(
    async (page = 0) => {
      try {
        setLoading(true);
        const endpoint = `${API_URL}/api/convertedLeads/customers/${user.id}?pageNumber=${page}&pageSize=${pageSize}`;

        const response = await axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        setLeads(response.data.customers || []);
        setTotalPages(response.data.totalPages || 0);
        setPageNumber(page); // Update current page number
      } catch (error) {
        console.log("Failed to fetch leads")
        // toast.error("Failed to fetch leads");
      } finally {
        setLoading(false);
      }
    },
    [user, pageSize]
  );

  useEffect(() => {
    fetchUsers();
    fetchLeads();
  }, [fetchLeads, fetchUsers, pageNumber, pageSize]);

  const handleUnconvertClick = (lead) => {
    setLeadToDelete(lead);
    setShowDeleteModal(true);
  };

  const handleUnconvertLead = async () => {
    if (!leadToDelete) return;

    try {
      await axios.delete(
        `${API_URL}/api/convertedLeads/unConvertLead/${leadToDelete.customerId}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setLeads(
        leads.filter((lead) => lead.customerId !== leadToDelete.customerId)
      );
      toast.success("Lead unconverted successfully");
    } catch (error) {
      toast.error("Failed to unconvert lead");
    } finally {
      setShowDeleteModal(false);
      setLeadToDelete(null);
    }
  };

  const isMaskedPhone = (value) => /^X+\d{0,3}$/.test(value || "");

  const handleEditClick = (lead) => {
    setEditingLead(lead);
    setEditForm({
      name: lead.name,
      email: lead.email,
      phone: isMaskedPhone(lead.phone) ? "" : lead.phone || "",
      companyName: lead.companyName || "",
      address: lead.address || "",
    });
    setShowEditModal(true);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...editForm };
      if (isMaskedPhone(editingLead?.phone) && !payload.phone) {
        delete payload.phone;
      }
      const response = await axios.put(
        `${API_URL}/api/convertedLeads/update/${editingLead.customerId}/changedBy/${user.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success("Lead updated successfully");
      setShowEditModal(false);
      // Refresh leads data
      fetchLeads(pageNumber);
    } catch (error) {
      toast.error("Failed to update lead");
      console.error("Error updating lead:", error);
    }
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      const fileExtension = uploadedFile.name.split(".").pop().toLowerCase();
      if (["xls", "xlsx", "csv"].includes(fileExtension)) {
        setFile(uploadedFile);
      } else {
        toast.error(
          "Only Excel (.xlsx, .xls) and CSV (.csv) files are allowed."
        );
        setFile(null);
      }
    }
  };

  const handleUploadFile = async (event) => {
    event.preventDefault();
    if (!file) {
      toast.error("Please select a valid file before uploading.");
      return;
    }

    if (!selectedUser) {
      toast.error("Please select an assigned user.");
      return;
    }

    const assignedUser = users.find((user) => user.id === selectedUser);
    if (!assignedUser) {
      toast.error("Assigned user not found.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "companyId",
      user.accountType === "COMPANY" ? user?.id : user.companyId
    );
    formData.append("createdById", user.id);
    formData.append("createdByName", user.name);
    formData.append("assignedToId", assignedUser.id);
    formData.append(
      "assignedToName",
      `${assignedUser.fname} ${assignedUser.lname}`
    );

    try {
      const response = await axios.post(
        `${API_URL}/api/convertedLeads/import/sheet`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success(response.data.message);
      setShowUploadSection(false);
      fetchLeads(pageNumber); // Refresh leads after upload
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(
        error.response?.data?.message ||
          "Error uploading file. Please try again."
      );
    }
  };

  const downloadExcelTemplate = () => {
    const worksheet = XLSX.utils.json_to_sheet([
      {
        "Lead Name": "",
        Email: "",
        Phone: "",
        companyName: "",
        "leadDate(02/05/2025)": "",
        Address: "",
      },
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "converted_lead_template.xlsx");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setIsSearching(true);
    setIsSearchMode(true);
    setPageNumber(0);

    try {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return;

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found");
        return;
      }

      const params = {
        pageNumber: 0,
        pageSize: pageSize,
        ...Object.fromEntries(
          Object.entries(searchParams).filter(([_, value]) => value !== "")
        ),
      };

      const response = await axios.get(
        `${API_URL}/api/convertedLeads/customers/${user?.id}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLeads(response.data?.customers || []);
      setTotalPages(response.data?.totalPages || 0);
      toast.success(`Found ${response.data?.customers?.length || 0} results`);
    } catch (error) {
      console.error("Search failed:", error);
      toast.error(
        error.response?.data?.message || "Search failed. Please try again."
      );
      setLeads([]);
      setTotalPages(0);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClearSearch = async () => {
    setSearchParams({
      targetUserId: "",
      startDate: "",
      endDate: "",
      query: "",
      createdAt: "",
    });
    setIsSearchMode(false);
    setPageNumber(0);
    await fetchLeads(0);
    toast.success("Search cleared");
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setPageNumber(0);
    if (isSearchMode) {
      handleSearchSubmit({ preventDefault: () => {} }); // Refetch with new page size
    } else {
      fetchLeads(0);
    }
  };

  return (
    <div className="container mx-auto p-2 sm:p-3 lg:p-4 dark:bg-gray-900 text-[#28194f] dark:text-white font-sans antialiased text-sm sm:text-base">
      <div className="bg-white shadow rounded-lg p-3 sm:p-4 dark:bg-gray-900 dark:text-white">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-3 gap-2 sm:gap-3">
          <h2 className="text-[22px] sm:text-[26px] lg:text-[30px] font-light leading-[1.25] tracking-tight">Converted Leads</h2>
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={() => setShowUploadSection(!showUploadSection)}
              className="p-2 bg-purple-500 text-white rounded-full hover:bg-purple-600 transition-colors"
              title="Upload leads"
            >
              <CloudArrowUpIcon className="w-5 h-5 sm:w-6 sm:h-6" />
            </button>
            <button
              type="button"
              onClick={() => setShowSearchFields(!showSearchFields)}
              className="flex items-center gap-1.5 px-3 py-1.5 sm:px-4 sm:py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-xs sm:text-sm font-semibold"
            >
              <FaSearch className="text-sm" />
              {showSearchFields ? "Hide Search" : "Search"}
            </button>
          </div>
        </div>

        {/* Upload Section */}
        {showUploadSection && (
          <div className="relative bg-white mt-1 p-3 sm:p-4 rounded shadow mb-3 border border-gray-200 dark:bg-gray-900 dark:text-white dark:border-gray-700 text-sm sm:text-base">
            <button
              onClick={() => setShowUploadSection(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
              aria-label="Close upload section"
            >
              <FiX className="h-5 w-5" />
            </button>

            <div className="space-y-3 pr-6 sm:pr-0 max-w-full sm:max-w-xl">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Assign User
                </label>
                <Select
                  showSearch
                  placeholder="Select user"
                  value={selectedUser || undefined}
                  onChange={(value) => setSelectedUser(value)}
                  options={users.map((user) => ({
                    value: user.id,
                    label: `${user.fname} ${user.lname}`,
                  }))}
                  className="w-full"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Upload File
                </label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="w-full p-1.5 border rounded text-sm sm:text-base dark:border-gray-600"
                  accept=".xlsx,.xls,.csv"
                />
              </div>

              <div className="text-sm text-gray-600 dark:text-gray-300">
                <p>
                  To preview the Excel format, click{" "}
                  <button
                    onClick={downloadExcelTemplate}
                    className="text-blue-500 underline hover:text-blue-700"
                  >
                    here
                  </button>
                  .
                </p>
              </div>

              <button
                onClick={handleUploadFile}
                className="mt-1 px-3 py-1.5 sm:px-4 sm:py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors flex items-center gap-1.5 text-xs sm:text-sm font-semibold"
              >
                <FiUpload className="w-4 h-4" />
                Upload
              </button>
            </div>
          </div>
        )}

        {showSearchFields && (
          <form
            onSubmit={handleSearchSubmit}
            className="bg-gray-50 p-3 sm:p-4 rounded-lg mb-4 shadow-sm dark:bg-gray-800 dark:text-white text-sm sm:text-base"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 dark:bg-gray-800 dark:text-white">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                  User
                </label>
                <Select
                  showSearch
                  allowClear
                  placeholder="Select user"
                  value={searchParams.targetUserId || undefined}
                  onChange={(value) =>
                    setSearchParams((prev) => ({
                      ...prev,
                      targetUserId: value,
                    }))
                  }
                  options={users.map((user) => ({
                    value: user.id,
                    label: `${user.fname} ${user.lname}`,
                  }))}
                  className="w-full dark:bg-gray-800"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                  Created At
                </label>
                <input
                  type="date"
                  name="createdAt"
                  value={searchParams.createdAt}
                  onChange={handleChange}
                  className="w-full p-1.5 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-600 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                  From Date
                </label>
                <input
                  type="date"
                  name="startDate"
                  value={searchParams.startDate}
                  onChange={handleChange}
                  className="w-full p-1.5 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-600 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                  To Date
                </label>
                <input
                  type="date"
                  name="endDate"
                  value={searchParams.endDate}
                  onChange={handleChange}
                  className="w-full p-1.5 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-600 text-sm sm:text-base"
                />
              </div>

              <div className="sm:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                  Search Query
                </label>
                <input
                  type="text"
                  name="query"
                  placeholder="Search by keyword"
                  value={searchParams.query}
                  onChange={handleChange}
                  className="w-full p-1.5 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-600 text-sm sm:text-base"
                />
              </div>
            </div>

            <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 mt-3">
              <button
                type="button"
                onClick={handleClearSearch}
                className="px-3 py-1.5 sm:px-4 sm:py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors flex items-center justify-center gap-1.5 text-xs sm:text-sm font-medium"
              >
                <FaTimes className="text-sm" />
                Clear
              </button>
              <button
                type="submit"
                className={`px-3 py-1.5 sm:px-4 sm:py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors flex items-center justify-center gap-1.5 text-xs sm:text-sm font-semibold ${
                  isSearching ? "opacity-75 cursor-not-allowed" : ""
                }`}
                disabled={isSearching}
              >
                {isSearching ? (
                  <>
                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Searching...
                  </>
                ) : (
                  <>
                    <FaSearch className="text-sm" />
                    Search
                  </>
                )}
              </button>
            </div>
          </form>
        )}

        <div className="overflow-x-auto -mx-3 sm:mx-0 px-3 sm:px-0">
          <table className="min-w-full divide-y divide-gray-200 text-sm sm:text-base">
            <thead className="bg-gray-50 dark:bg-gray-900 dark:text-white">
              <tr>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Name
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Email
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Phone
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Company
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Converted By
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Converted Date
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Lead Details
                </th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider dark:text-white whitespace-nowrap">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:text-white">
              {loading ? (
                <tr>
                  <td colSpan="8" className="px-3 py-4 text-center">
                    <div className="flex justify-center">
                      <svg
                        className="animate-spin h-6 w-6 text-indigo-600"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    </div>
                  </td>
                </tr>
              ) : leads.length > 0 ? (
                leads.map((lead) => (
                  <tr key={lead.customerId} className="hover:bg-gray-50 dark:hover:bg-gray-900 dark:text-white">
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base font-medium text-gray-900 dark:text-white">
                      {lead.name}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base text-gray-500 dark:text-white">
                      {lead.email}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base text-gray-500 dark:text-white">
                      {lead.phone || "-"}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base text-gray-500 dark:text-white">
                      {lead.companyName || "-"}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base text-gray-500 dark:text-white">
                      {lead.convertedByName}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base text-gray-500 dark:text-white">
                      {new Date(lead.convertedDate).toLocaleString()}
                    </td>
                    <td className="px-3 py-2 text-sm sm:text-base text-gray-500 dark:text-white min-w-[160px]">
                      {lead.lead ? (
                        <div className="leading-tight">
                          <div>
                            {lead.lead.status || "-"}
                            {lead.lead.sourceName ? ` · ${lead.lead.sourceName}` : ""}
                          </div>
                          <div className="text-gray-400 text-xs md:text-sm">
                            {lead.lead.projectName || ""}
                            {lead.lead.assignedToName ? ` · ${lead.lead.assignedToName}` : ""}
                          </div>
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm sm:text-base text-gray-500 dark:text-white">
                      {(user?.id === lead.convertedById ||
                        user?.accountType === "COMPANY") && (
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleEditClick(lead)}
                            className="text-indigo-600 hover:text-indigo-900 p-1 rounded hover:bg-indigo-50"
                            title="Edit"
                          >
                            <FiEdit className="h-4 w-4 md:h-5 md:w-5" />
                          </button>
                          <button
                            onClick={() => handleUnconvertClick(lead)}
                            className="text-red-600 hover:text-red-900 p-1 rounded hover:bg-red-50"
                            title="Unconvert"
                          >
                            <FiTrash2 className="h-4 w-4 md:h-5 md:w-5" />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="8"
                    className="px-3 py-4 text-center text-sm sm:text-base text-gray-500 dark:text-gray-300"
                  >
                    No converted leads found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 0 && (
          <div className="mt-4 flex flex-col md:flex-row justify-between items-center gap-3">
            <div className="flex items-center gap-2">
              <span className="text-sm sm:text-base text-gray-600 dark:text-white">Items per page:</span>
              <Select
                defaultValue={10}
                value={pageSize}
                onChange={handlePageSizeChange}
                className="w-20 text-sm"
                options={[
                  { value: 5, label: "5" },
                  { value: 10, label: "10" },
                  { value: 20, label: "20" },
                  { value: 50, label: "50" },
                ]}
              />
            </div>

            <div className="flex flex-wrap justify-center items-center gap-1.5 sm:gap-2">
              <button
                onClick={() => {
                  setPageNumber(0);
                  if (isSearchMode) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  } else {
                    fetchLeads(0);
                  }
                }}
                disabled={pageNumber === 0}
                className="px-2.5 py-1 sm:px-3 sm:py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs sm:text-sm font-medium"
              >
                First
              </button>

              <button
                onClick={() => {
                  const newPage = Math.max(pageNumber - 1, 0);
                  setPageNumber(newPage);
                  if (isSearchMode) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  } else {
                    fetchLeads(newPage);
                  }
                }}
                disabled={pageNumber === 0}
                className="px-2.5 py-1 sm:px-3 sm:py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs sm:text-sm font-medium"
              >
                Previous
              </button>

              <span className="text-sm sm:text-base font-medium text-gray-700 dark:text-white px-1">
                Page {pageNumber + 1} of {totalPages}
              </span>

              <button
                onClick={() => {
                  const newPage = Math.min(pageNumber + 1, totalPages - 1);
                  setPageNumber(newPage);
                  if (isSearchMode) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  } else {
                    fetchLeads(newPage);
                  }
                }}
                disabled={pageNumber >= totalPages - 1}
                className="px-2.5 py-1 sm:px-3 sm:py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs sm:text-sm font-medium"
              >
                Next
              </button>

              <button
                onClick={() => {
                  setPageNumber(totalPages - 1);
                  if (isSearchMode) {
                    handleSearchSubmit({ preventDefault: () => {} });
                  } else {
                    fetchLeads(totalPages - 1);
                  }
                }}
                disabled={pageNumber >= totalPages - 1}
                className="px-2.5 py-1 sm:px-3 sm:py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-xs sm:text-sm font-medium"
              >
                Last
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Edit Lead Modal */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-3 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md md:max-w-lg max-h-[90vh] overflow-y-auto text-sm sm:text-base">
            <div className="flex justify-between items-center border-b p-3 sm:p-4">
              <h3 className="text-base sm:text-lg font-medium tracking-tight text-[#28194f]">Edit Lead</h3>
              <button
                onClick={() => setShowEditModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="h-5 w-5" />
              </button>
            </div>
            <form onSubmit={handleEditSubmit} className="p-3 sm:p-4 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={editForm.name}
                  onChange={handleEditFormChange}
                  className="w-full p-1.5 sm:p-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm sm:text-base"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={editForm.email}
                  onChange={handleEditFormChange}
                  className="w-full p-1.5 sm:p-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm sm:text-base"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={editForm.phone}
                  placeholder={isMaskedPhone(editingLead?.phone) ? "Hidden - leave blank to keep" : ""}
                  onChange={handleEditFormChange}
                  className="w-full p-1.5 sm:p-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Company Name
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={editForm.companyName}
                  onChange={handleEditFormChange}
                  className="w-full p-1.5 sm:p-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Address
                </label>
                <textarea
                  name="address"
                  value={editForm.address}
                  onChange={handleEditFormChange}
                  className="w-full p-1.5 sm:p-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm sm:text-base"
                  rows="2"
                ></textarea>
              </div>

              <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={() => setShowEditModal(false)}
                  className="px-3 py-1.5 sm:px-4 sm:py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors text-xs sm:text-sm font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-3 py-1.5 sm:px-4 sm:py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-xs sm:text-sm font-semibold"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      
      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-3 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto text-sm sm:text-base">
            <div className="flex justify-between items-center border-b p-3 sm:p-4">
              <h3 className="text-base sm:text-lg font-medium tracking-tight text-[#28194f]">Confirm Unconvert</h3>
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setLeadToDelete(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="h-5 w-5" />
              </button>
            </div>
            <div className="p-3 sm:p-4">
              <p className="mb-3 text-sm sm:text-base font-normal leading-[1.75]">
                Are you sure you want to unconvert this lead? This action cannot
                be undone.
              </p>
              <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
                <button
                  onClick={() => {
                    setShowDeleteModal(false);
                    setLeadToDelete(null);
                  }}
                  className="px-3 py-1.5 sm:px-4 sm:py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors text-xs sm:text-sm font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleUnconvertLead}
                  className="px-3 py-1.5 sm:px-4 sm:py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-xs sm:text-sm font-semibold"
                >
                  Unconvert
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConvertedLeads;